import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./components/Home/Home";
import Signup from "./components/Signup";
import Login from "./components/Login";
import FoodDetail from "./components/FoodDetail/FoodDetail";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/food/:id" element={<FoodDetail />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;